import { combineReducers } from 'redux';

import resultGrid from './resultgrid/reducer';

export default combineReducers({
  resultGrid,
});



// WEBPACK FOOTER //
// ./src/pages/importresult/state/reducer.js